var map = {
	"./1.png": 4308,
	"./10.png": 1582,
	"./11.png": 1079,
	"./12.png": 7148,
	"./13.png": 9413,
	"./2.png": 9423,
	"./3.png": 4230,
	"./4.png": 6649,
	"./5.png": 400,
	"./6.png": 4219,
	"./7.png": 3714,
	"./8.png": 5093,
	"./9.png": 2828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;